/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    global: {
        '*': {
            WebkitTapHighlightColor: 'transparent'
        },
        'html, body': {
            backgroundColor: 'white',
            color: 'black'
        },
        body: {
            minHeight: '100vh'
        },
        '.react-target': {
            display: 'flex',
            minHeight: '100vh'
        },
        '*[role="button"]': {
            _focusVisible: {
                outline: 0,
                boxShadow: 'var(--chakra-shadows-outline)'
            }
        },
        '.js-only': {
            display: 'none'
        },
        '.js-enabled .js-only': {
            display: 'block'
        },
        '.js-enabled .no-js-only': {
            display: 'none'
        },
        // Force first accordion panel open in SSR (before js-enabled is added).
        // After hydration, framer-motion takes over via inline styles.
        'html:not(.js-enabled) .pdp-accordion > .chakra-accordion__item:first-of-type .chakra-collapse': {
            height: 'auto !important',
            opacity: '1 !important',
            overflow: 'visible !important',
            display: 'block !important'
        }
    }
}
